"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPeriodCard = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var ProgressBar_1 = require("../../../../components/ProgressBar");
var copy_1 = require("../../../../copy");
var sandwich_ids_1 = require("../../../../sandwich-ids");
var billing_1 = require("../../../../utils/billing");
var date_1 = require("../../../../utils/date");
var BillingPeriodCard_styled_1 = require("./BillingPeriodCard.styled");
exports.BillingPeriodCard = (0, react_1.memo)(function (_a) {
    var _b, _c, _d;
    var startDate = _a.startDate, endDate = _a.endDate, charge = _a.charge, _e = _a.periodId, periodId = _e === void 0 ? '' : _e, displayStatus = _a.displayStatus, position = _a.position;
    var billingDetails = (0, core_1.useLinks)().billingDetails;
    var _f = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _f.copy, Copy = _f.Copy;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var colors = (0, styled_components_1.useTheme)().colors;
    var colorPalettes = {
        existing: { base: 'primary', muted: 'primaryMuted' },
        current: { base: 'primary', muted: 'primaryMuted' },
        skeleton: { base: 'borderMuted', muted: 'canvasMuted' },
    };
    if (displayStatus === 'empty' || !startDate || !endDate || !charge) {
        return (react_1.default.createElement(BillingPeriodCardInner, { dataTestId: 'billing-period-card-' + displayStatus, StatusText: react_1.default.createElement(Copy, { copyKey: "comingSoon" }), Image: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.periodCards.empty },
                react_1.default.createElement(BillingPeriodCard_styled_1.StyledBillImage, { color: colors[colorPalettes.skeleton.base] })), colorPalette: colorPalettes.skeleton }));
    }
    if (displayStatus === 'current') {
        return (react_1.default.createElement(BillingPeriodCardInner, { dataTestId: 'billing-period-card-' + displayStatus, startDate: startDate, endDate: endDate, Image: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.periodCards.current },
                react_1.default.createElement(BillingPeriodCard_styled_1.StyledClockImage, { color: colors[colorPalettes.current.base] })), charge: parseInt(charge) === 0
                ? copy('noChargesYet')
                : (0, core_1.major2DP)((0, core_1.majorToMinor)(charge)), StatusText: react_1.default.createElement(Copy, { copyKey: "billingSummaryDaysRemaining", values: {
                    count: (0, billing_1.getBillingPeriodProgress)(startDate, endDate)
                        .daysRemaining,
                } }), FooterLink: react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_DETAILS_LINK, properties: (_b = {
                        status: displayStatus,
                        position: position
                    },
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b) },
                react_1.default.createElement(TextLink, { href: billingDetails() }, copy('viewDetails'))), colorPalette: colorPalettes.current }));
    }
    if (displayStatus === 'pending') {
        return (react_1.default.createElement(BillingPeriodCardInner, { dataTestId: 'billing-period-card-' + displayStatus, StatusText: react_1.default.createElement(Copy, { copyKey: "billPending" }), startDate: startDate, endDate: endDate, charge: parseInt(charge) === 0
                ? copy('noCharges')
                : (0, core_1.major2DP)((0, core_1.majorToMinor)(charge)), FooterLink: react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_DETAILS_LINK, properties: (_c = {
                        status: displayStatus,
                        position: position
                    },
                    _c[core_1.INTERNAL_EVENT_FLAG] = true,
                    _c) },
                react_1.default.createElement(TextLink, { href: billingDetails({ periodId: periodId }) }, copy('viewDetails'))), Image: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.periodCards.pending },
                react_1.default.createElement(BillingPeriodCard_styled_1.StyledBillImage, { color: colors[colorPalettes.existing.base] })), colorPalette: colorPalettes.existing }));
    }
    // displayStatus "endDated" as default
    return (react_1.default.createElement(BillingPeriodCardInner, { dataTestId: 'billing-period-card-' + displayStatus, StatusText: react_1.default.createElement(Copy, { copyKey: "billAvailable" }), startDate: startDate, endDate: endDate, charge: parseInt(charge) === 0
            ? copy('noCharges')
            : (0, core_1.major2DP)((0, core_1.majorToMinor)(charge)), FooterLink: react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_DETAILS_LINK, properties: (_d = {
                    status: displayStatus,
                    position: position
                },
                _d[core_1.INTERNAL_EVENT_FLAG] = true,
                _d) },
            react_1.default.createElement(TextLink, { href: billingDetails({ periodId: periodId }) }, copy('viewDetails'))), Image: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.periodCards.historical },
            react_1.default.createElement(BillingPeriodCard_styled_1.StyledBillImage, { color: colors[colorPalettes.existing.base] })), colorPalette: colorPalettes.existing }));
});
var BillingPeriodCardInner = (0, react_1.memo)(function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, StatusText = _a.StatusText, charge = _a.charge, FooterLink = _a.FooterLink, Image = _a.Image, dataTestId = _a.dataTestId, colorPalette = _a.colorPalette;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, P = _b.P, Strong = _b.Strong;
    var billPeriodProgress = (0, billing_1.getBillingPeriodProgress)(startDate, endDate);
    var periodRange = !!(startDate && endDate)
        ? (0, date_1.formatHeadingDateRange)(startDate, endDate, true)
        : null;
    return (react_1.default.createElement(BillingPeriodCard_styled_1.StyledFlexCenter, { backgroundColor: colorPalette.muted, borderColor: colorPalette.base, as: Card, "data-testid": "".concat(dataTestId, " billing-period-card-inner") },
        react_1.default.createElement(P, null,
            react_1.default.createElement(Strong, null, periodRange ? (periodRange.startDate + ' - ' + periodRange.endDate) : (react_1.default.createElement(react_1.default.Fragment, null, "\u00A0")))),
        Image,
        react_1.default.createElement(P, null,
            react_1.default.createElement(Strong, null, charge || react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"))),
        react_1.default.createElement(BillingPeriodCard_styled_1.StyledProgressWrapper, null,
            react_1.default.createElement(ProgressBar_1.ProgressBar, { progress: billPeriodProgress === null || billPeriodProgress === void 0 ? void 0 : billPeriodProgress.progress, total: billPeriodProgress === null || billPeriodProgress === void 0 ? void 0 : billPeriodProgress.total, barForegroundColor: colorPalette.base, barBackgroundColor: colorPalette.muted }, StatusText)),
        react_1.default.createElement(BillingPeriodCard_styled_1.StyledFooter, { as: P, "data-testid": "billing-period-card-footer-link" }, FooterLink || react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"))));
});
